const MAIN_PACKAGE_NAME = 'reviews-package';
const STATS_PREFIX = 'packages.reviews_package';

const FILTER_TYPES = {
    recent: 'all',
    relevant: 'relevant',
    positive: 'positive',
    negative: 'negative',
    breakdown: 'breakdown',
    work_sample: 'work_sample',
    industry: 'industry',
    business: 'business',
    text: 'text',
    local_reviews: 'local_reviews',
};

const DEFAULT_FILTER_TYPE = FILTER_TYPES.recent;

const RECENT_SORT = 'recent';
const REVIEWS_HEADER = 'reviews_header';
const TEXT = 'text';

const SORT_BY_TYPES = [FILTER_TYPES.recent, FILTER_TYPES.relevant, FILTER_TYPES.local_reviews];
const FILTER_BY_TYPES = [
    FILTER_TYPES.positive,
    FILTER_TYPES.negative,
    FILTER_TYPES.breakdown,
    FILTER_TYPES.work_sample,
];

const HELPFUL_STORAGE_KEY = 'reviews-helpful';
const HELPFUL_STATS_PREFIX = 'helpful_reviews.click';

const ON = 'on';
const OFF = 'off';
const DEFAULT_LOCALE = 'en-US';

const USER_SMALL_IMAGE_SIZE = 24;
const USER_IMAGE_SIZE = 32;
const MAIN_USER_IMAGE_SIZE = 48;

const OTHER = 'other';
const NON_EXISTING_REVIEW = {
    id: '0',
    score: 1,
};

const MOBILE_MAX_COMMENT_LENGTH = 200;
const MAX_COMMENT_LENGTH = 240;
const MOBILE_MAX_SELLER_RESPONSE_LENGTH = 100;
const DESKTOP_MAX_SELLER_RESPONSE_LENGTH = 150;
const HIGHLIGHTED_REVIEW_ITEM_DESCRIPTION_MAX_LENGTH = 155;

const INTERSECTION_OBSERVER_UNDEFINED = 'intersection_observer.not_supported';
const FETCH_REVIEWS = 'fetch_reviews.failed';
const NO_REVIEWS = 'fetch_reviews.no_reviews';
const NO_DATA_RETURNED = 'No data returned';

const TRANSLATION_TIMEOUT = 5000;
const OK_STATUS = 200;
const LOADING_TIMEOUT = 700;

const PRICE_RANGES_SUPPORTED_CURRENCIES = ['USD', 'EUR', 'GBP', 'AUD', 'CAD', 'ILS', 'CHF'];

const INDUSTRY_RECOMMENDATIONS_SOURCE = 'industry_based_gigs';

module.exports = {
    MAIN_PACKAGE_NAME,
    STATS_PREFIX,
    FILTER_TYPES,
    DEFAULT_FILTER_TYPE,
    RECENT_SORT,
    REVIEWS_HEADER,
    TEXT,
    SORT_BY_TYPES,
    FILTER_BY_TYPES,
    HELPFUL_STORAGE_KEY,
    HELPFUL_STATS_PREFIX,
    ON,
    OFF,
    DEFAULT_LOCALE,
    USER_IMAGE_SIZE,
    MAIN_USER_IMAGE_SIZE,
    USER_SMALL_IMAGE_SIZE,
    OTHER,
    NON_EXISTING_REVIEW,
    MAX_COMMENT_LENGTH,
    MOBILE_MAX_COMMENT_LENGTH,
    MOBILE_MAX_SELLER_RESPONSE_LENGTH,
    DESKTOP_MAX_SELLER_RESPONSE_LENGTH,
    INTERSECTION_OBSERVER_UNDEFINED,
    FETCH_REVIEWS,
    NO_REVIEWS,
    NO_DATA_RETURNED,
    TRANSLATION_TIMEOUT,
    OK_STATUS,
    LOADING_TIMEOUT,
    PRICE_RANGES_SUPPORTED_CURRENCIES,
    INDUSTRY_RECOMMENDATIONS_SOURCE,
    HIGHLIGHTED_REVIEW_ITEM_DESCRIPTION_MAX_LENGTH,
};
